export default{
    // confirmation
    "clinic.detail.cart.confirmation.title"               : "Registration Confirmation",
    "clinic.detail.cart.confirmation.thankYou"            : "Thank you for registering!",
    "clinic.detail.cart.confirmation.receiptNumber"       : "Your receipt number is",
    "clinic.detail.cart.confirmation.emailSentTo"         : "An email confirmation has been sent to",
    "clinic.detail.cart.confirmation.attacments.title"    : "Here are the attachments supplied by your clinic.",
    "clinic.detail.cart.confirmation.attacments.subtitle" : "Click to download",
}